@if (cosmeticControls.highlightOptionsOpen) {
  <div class="filter {{ filterClasses }}">
    <span class="filter-body">
      <div class="filter-title" style="width: 90px">
        Highlight
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [disabled]="!active" [class.off]="!cosmeticOptions.highlight" (click)="toggleHighlight()"></button>
        </span>
        <span class="table-checkbox-label">Map Icon</span>
      </div>
      <span class="sep"></span>
      <app-select style="width: 85px" [(ngModel)]="cosmeticOptions.highlightColor" (selectedValueChange)="updateFilter()" [disabled]="!active || !cosmeticOptions.highlight">
        @for (color of tierStyleMap; track color[0]) {
          <app-option [value]="color[0]" [text]="color[0]" [color]="'var(--' + color[1] + '-color)'"></app-option>
        }
      </app-select>
      <span class="sep"></span>
      <app-select style="width: 90px" [(ngModel)]="cosmeticOptions.minimapIconSize" (selectedValueChange)="updateFilter()" [disabled]="!active || !cosmeticOptions.highlight">
        <app-option [value]="MinimapIconSize.Small" [text]="'Small'"></app-option>
        <app-option [value]="MinimapIconSize.Medium" [text]="'Medium'"></app-option>
        <app-option [value]="MinimapIconSize.Large" [text]="'Large'"></app-option>
      </app-select>
      <span class="sep"></span>
      <app-select-minimap-icon [(ngModel)]="cosmeticOptions.minimapIconShape" (selectedValueChange)="updateFilter()"
        [disabled]="!active || !cosmeticOptions.highlight"></app-select-minimap-icon>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group" [class.disabled]="!active || !cosmeticOptions.highlight">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!cosmeticOptions.beam" [disabled]="!active || !cosmeticOptions.highlight"
            (click)="cosmeticOptions.beam = !cosmeticOptions.beam; updateFilter();"></button>
        </span>
        <span class="table-checkbox-label">Beam</span>
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group" [class.disabled]="!active || !cosmeticOptions.highlight || !cosmeticOptions.beam">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!cosmeticOptions.temp" [disabled]="!active || !cosmeticOptions.highlight || !cosmeticOptions.beam"
          (click)="cosmeticOptions.temp = !cosmeticOptions.temp; updateFilter();"></button>
        </span>
        <span class="table-checkbox-label">
          <span class="filter-title-text">Temp</span>
          <div class="filter-tip">
            <p>If enabled, the beam will only be shown for a short time, then disappear.</p>
          </div>
        </span>
      </div>
      <span class="filler"></span>
    </span>
  </div>
}

@if (cosmeticControls.soundOptionsOpen) {
  <div class="filter {{ filterClasses }}">
    <span class="filter-body">
      <div class="filter-title" style="width: 90px">
        <span class="filter-title-text">Sound</span>
        <div class="filter-tip">
          <p>
            The first box determines the Alert Sound to play when this item drops. Your browser will play the sound when you select it. Note that this does not replace the Drop Sound.

            <br /><br />Next, specify the sound volume of the alert sound. Note that this does not change the Drop Sound's volume, this is not possible.

            <br /><br />To use a custom sound, put the .mp3 file in the game's filter directory, next to the filter file, and enter the filename in the 'Custom.mp3' box.
          </p>
        </div>
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group" [class.disabled]="!active || !cosmeticOptions.alertSound">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!cosmeticOptions.alertSound" [disabled]="!active"
          (click)="toggleSound()"></button>
        </span>
        <span class="table-checkbox-label">Alert Sound</span>
      </div>
      <span class="sep"></span>
      <app-select style="width: 100px" [(ngModel)]="cosmeticOptions.alertSoundSound"
        (selectedValueChange)="playSound(cosmeticOptions.alertSoundSound); updateFilter();" [disabled]="!active || !cosmeticOptions.alertSound || !!cosmeticOptions.customAlertSound">
        <app-option [value]="'1'" [text]="'1'"></app-option>
        <app-option [value]="'2'" [text]="'2'"></app-option>
        <app-option [value]="'3'" [text]="'3'"></app-option>
        <app-option [value]="'4'" [text]="'4'"></app-option>
        <app-option [value]="'5'" [text]="'5'"></app-option>
        <app-option [value]="'6'" [text]="'6'"></app-option>
        <app-option [value]="'7'" [text]="'7'"></app-option>
        <app-option [value]="'8'" [text]="'8'"></app-option>
        <app-option [value]="'9'" [text]="'9'"></app-option>
        <app-option [value]="'10'" [text]="'10'"></app-option>
        <app-option [value]="'11'" [text]="'11'"></app-option>
        <app-option [value]="'12'" [text]="'12'"></app-option>
        <app-option [value]="'13'" [text]="'13'"></app-option>
        <app-option [value]="'14'" [text]="'14'"></app-option>
        <app-option [value]="'15'" [text]="'15'"></app-option>
        <app-option [value]="'16'" [text]="'16'"></app-option>
        <app-option [value]="'ShRegal'" [text]="'Regal'"></app-option>
        <app-option [value]="'ShVaal'" [text]="'Vaal'"></app-option>
        <app-option [value]="'ShAlchemy'" [text]="'Alchemy'"></app-option>
        <app-option [value]="'ShExalted'" [text]="'Exalted'"></app-option>
        <app-option [value]="'ShChaos'" [text]="'Chaos'"></app-option>
        <app-option [value]="'ShDivine'" [text]="'Divine'"></app-option>
        <app-option [value]="'ShMirror'" [text]="'Mirror'"></app-option>
        <app-option [value]="'ShGeneral'" [text]="'General'"></app-option>
      </app-select>
      <span class="sep"></span>
      @if (settings.numericAlertSoundVolume()) {
        <input type="number" placeholder="vol" min="1" max="300" maxlength="3" pattern="[0-9]*" inputmode="numeric" step="any" class="form-control minmax" style="width: 55px;"
          [(ngModel)]="cosmeticOptions.alertSoundVolume" (change)="updateFilter()"
          [disabled]="!active || !cosmeticOptions.alertSound">
      } @else {
        <app-select style="width: 90px" [(ngModel)]="cosmeticOptions.alertSoundVolume" (selectedValueChange)="updateFilter()"
          [disabled]="!active || !cosmeticOptions.alertSound">
          <app-option [value]="50" [text]="'Quiet'"></app-option>
          <app-option [value]="100" [text]="'Default'"></app-option>
          <app-option [value]="200" [text]="'Louder'"></app-option>
          <app-option [value]="300" [text]="'Max'"></app-option>
        </app-select>
      }
      <span class="sep"></span>
      <input type="text" class="form-control" placeholder="Custom.mp3" [disabled]="!active || !cosmeticOptions.alertSound" style="width: 100px;"
        [(ngModel)]="cosmeticOptions.customAlertSound" (change)="updateFilter()" (keydown)="nameChangeKeyDown($event)">
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group" [class.disabled]="!active">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [class.off]="!cosmeticOptions.disableDropSound" [disabled]="!active"
            (click)="cosmeticOptions.disableDropSound = !cosmeticOptions.disableDropSound; updateFilter();"></button>
        </span>
        <span class="table-checkbox-label">
          <span class="filter-title-text">Disable Drop Sound</span>
          <div class="filter-tip"><p>Disable the game's default sound when the item <i>drops</i> — this is different from the Alert Sound specified here.</p></div>
        </span>
      </div>
      <span class="spacer" style="display: table-cell; width: 100%;"></span>
    </span>
  </div>
}

@if (cosmeticControls.labelOptionsOpen) {
  <div class="filter {{ filterClasses }}">
    <span class="filter-body">
      <div class="filter-title" style="width: 90px">
        Label
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label color-picker-label table-checkbox-group" [class.disabled]="!active || !cosmeticOptions.backgroundColor">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [disabled]="!active" [class.off]="!cosmeticOptions.backgroundColor" (click)="toggleBackgroundColor()"></button>
        </span>

        <span class="table-checkbox-label">
          <span class="color-picker-label-text" title="Background">BG</span>

          <input type="text" maxlength="9" pattern="#[0-9a-fA-F]*" class="color-picker-dot"
            [disabled]="!cosmeticOptions.backgroundColor"
            [(colorPicker)]="cosmeticOptions.backgroundColor!" [style.background]="cosmeticOptions.backgroundColor"
            cpOutputFormat="hex" cpAlphaChannel="always" [cpPresetColors]="presetColors()"
            (ngModelChanged)="cosmeticOptions.backgroundColor" (colorPickerSelect)="colorPicked($event)">
          </span>
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label color-picker-label table-checkbox-group" [class.disabled]="!active || !cosmeticOptions.borderColor">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [disabled]="!active" [class.off]="!cosmeticOptions.borderColor" (click)="toggleBorderColor()"></button>
        </span>

        <span class="table-checkbox-label">
          <span class="color-picker-label-text">Border</span>

          <input type="text" maxlength="9" pattern="#[0-9a-fA-F]*" class="color-picker-dot"
            [disabled]="!cosmeticOptions.borderColor"
            [(colorPicker)]="cosmeticOptions.borderColor!" [style.background]="cosmeticOptions.borderColor"
            cpOutputFormat="hex" cpAlphaChannel="always" [cpPresetColors]="presetColors()"
            (ngModelChanged)="cosmeticOptions.borderColor" (colorPickerSelect)="colorPicked($event)">
        </span>
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label color-picker-label table-checkbox-group" [class.disabled]="!active || !cosmeticOptions.textColor">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [disabled]="!active" [class.off]="!cosmeticOptions.textColor" (click)="toggleTextColor()"></button>
        </span>

        <span class="table-checkbox-label">
          <span class="color-picker-label-text">Text</span>

          <input type="text" maxlength="9" pattern="#[0-9a-fA-F]*" class="color-picker-dot"
            [disabled]="!cosmeticOptions.textColor"
            [(colorPicker)]="cosmeticOptions.textColor!" [style.background]="cosmeticOptions.textColor"
            cpOutputFormat="hex" cpAlphaChannel="always" [cpPresetColors]="presetColors()"
            (ngModelChanged)="cosmeticOptions.textColor" (colorPickerSelect)="colorPicked($event)">
        </span>
      </div>
      <span class="sep"></span>
      <div class="filter-title filter-label table-checkbox-group" [class.disabled]="!active || !cosmeticOptions.fontSize">
        <span class="input-group-btn">
          <button class="btn toggle-btn" [disabled]="!active" [class.off]="!cosmeticOptions.fontSize" (click)="toggleFontSize()"></button>
        </span>
        <span class="table-checkbox-label">
          Size
        </span>
      </div>
      <span class="sep"></span>
      <app-select style="width: 100px" [(ngModel)]="cosmeticOptions.fontSize" (selectedValueChange)="updateFilter()"
        [disabled]="!active || !cosmeticOptions.fontSize">
        <app-option [value]="LabelSize.Smallest" [text]="'Smallest'"></app-option>
        <app-option [value]="LabelSize.Smaller" [text]="'Smaller'"></app-option>
        <app-option [value]="LabelSize.Small" [text]="'Small'"></app-option>
        <app-option [value]="LabelSize.Normal" [text]="'Normal'"></app-option>
        <app-option [value]="LabelSize.Large" [text]="'Large'"></app-option>
        <app-option [value]="LabelSize.Larger" [text]="'Larger'"></app-option>
        <app-option [value]="LabelSize.Largest" [text]="'Largest'"></app-option>
      </app-select>
      <div class="filler"></div>
    </span>
  </div>
}
